import React, { useContext } from "react";
import GeoUnitTable from "../components/GeoUnit/GeoUnitTable";
import { context } from "./../context/context";
const GeoUnit = () => {
  const { ostan, shahrestan, shahr } = useContext(context);
  return (
    <>
      <GeoUnitTable ostan={ostan} shahrestan={shahrestan} shahr={shahr} />
    </>
  );
};

export default GeoUnit;
